import { createLookupHook } from "./createLookupHook";
export type PropertyStatusName = 'draft' | 'pending_review' | 'active' | 'suspended' | 'archived';
export type UnitStatusName = 'available' | 'occupied' | 'reserved' | 'maintenance' | 'inactive';
export type UnitTypeName = 'room' | 'bed' | 'tent_slot' | 'apartment' | 'cabin' | 'house';
export type ImageTypeName = 'cover' | 'gallery' | 'thumbnail' | 'floorplan';

export interface BaseLookupItem {
  id: number;
  description: string | null;
  createdAt: string;
}

export interface PropertyLookupItem extends BaseLookupItem { name: PropertyStatusName; }
export interface UnitStatusItem extends BaseLookupItem { name: UnitStatusName; }
export interface UnitTypeItem extends BaseLookupItem { name: UnitTypeName; }
export interface ImageTypeItem extends BaseLookupItem { name: ImageTypeName; }

export interface PropertyLookupsData {
  propertyStatuses: PropertyLookupItem[];
  unitStatuses: UnitStatusItem[];
  unitTypes: UnitTypeItem[];
  imageTypes: ImageTypeItem[];
}

export interface PropertyLookupsResponse {
  success: boolean;
  message: string;
  data: PropertyLookupsData;
}

export const usePropertyLookups = createLookupHook<PropertyLookupsData>(
  "property",
  "/lookups/property",
);
